import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RegistrationState } from '../../definitions/registration.interface';
import { RegistrationService } from '../../registration.service';
import { TermsAndPrivacy } from 'projects/tmhna-portal/src/app/services/shared/shared-enums';
import { ModalEvent } from 'kinetic-angular';

@Component({
	selector: 'tmhna-portal-registration-terms-and-conditions',
	templateUrl: './registration-terms-and-conditions.component.html',
	styleUrls: ['./registration-terms-and-conditions.component.scss']
})
export class RegistrationTermsAndConditionsComponent implements OnInit
{
	termsChecked: boolean = false;
	privacyChecked: boolean = false;
	@Input() set state(value: RegistrationState)
	{
		this.service.updateState(value);
	}
	get state(): RegistrationState
	{
		return this.service.state;
	}

	isRaymond: boolean = false;

	public termsAndConditions: boolean = false;
	public termsAndConditionsDisabled: boolean = true;
	checkBoxTerms: string =  '';
	checkBoxPrivacy: string = '';
	checkBoxTickedFlagTandC: boolean = false;
	checkBoxTickedFlagPrivacy: boolean = false;
	isAtBottomTandC: boolean = false;
	isAtBottomPrivacy: boolean = false;
	checkBoxDisabledFlagTandC: boolean = true;
	checkBoxDisabledFlagPrivacy: boolean = true;
	public privacyPolicy: boolean = false;
	public privacyPolicyDisabled: boolean = true;
	@ViewChild('terms') terms: ElementRef | undefined;
	@ViewChild('policy') policy: ElementRef | undefined;
	@Output() termsAndPolicyConditionAgreed: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(public service: RegistrationService) {}

	ngOnInit()
	{
		this.isRaymond = this.service.isRaymond || false;
		this.state.termsModal.buttons[0].disabled = true;
		this.state.policyModal.buttons[0].disabled = true;
		this.state.termsModal.isCheckBox = true;
		this.state.policyModal.isCheckBox = true;
	}
	onScrollTandC(event: Event)
	{
		const target = event.target as HTMLElement;
		this.isAtBottomTandC = target.scrollTop + target.clientHeight >= target.scrollHeight - 10;
		if(this.isAtBottomTandC && !this.termsAndConditions)
		{
			this.checkBoxDisabledFlagTandC = false;
		}
	}

	onScrollPrivacy(event: Event)
	{
		const target = event.target as HTMLElement;
		this.isAtBottomPrivacy = target.scrollTop + target.clientHeight >= target.scrollHeight - 10;
		if(this.isAtBottomPrivacy && !this.privacyPolicy)
		{
			this.checkBoxDisabledFlagPrivacy = false;
		}
	}
	checkBoxTermsData() 
	{
		this.checkBoxTerms = this.state.registrationPage.termsConditions.terms.modal.checkboxText;
		return this.checkBoxTerms;
	}
	checkBoxPrivacyData()
	{
		this.checkBoxPrivacy = this.state.registrationPage.termsConditions.privacy.modal.checkboxText;
		return this.checkBoxPrivacy;
	}
	public agreeToConditionsOrPolicyAgreement(event: ModalEvent): void
	{
		let privacyPolicyLinkElement: HTMLElement | null = null;
		if (event.state.label === TermsAndPrivacy.termsAndConditions)
		{
			this.termsAndConditions = true;
			this.service.state.termsModal.buttons[0].disabled = true;
			this.service.state.termsModal.buttons[0].label = this.state.registrationPage.termsConditions.terms.modal.agreedButtonLabel;
			privacyPolicyLinkElement = document.getElementById('privacyPolicy');
			this.checkBoxTickedFlagTandC = true;
			this.checkBoxDisabledFlagTandC = true;
		}
		else if (event.state.label === TermsAndPrivacy.privacyPolicy)
		{
			this.privacyPolicy = true;
			this.service.state.policyModal.buttons[0].disabled = true;
			this.service.state.policyModal.buttons[0].label = this.state.registrationPage.termsConditions.privacy.modal.agreedButtonLabel;
			this.checkBoxTickedFlagPrivacy = true;
			this.checkBoxDisabledFlagPrivacy = true;
		}
		event.state.hidden = true;
		const ele = document.getElementById('kng-modal-close');
		if (ele)
		{
			ele.click();
		}
		if (privacyPolicyLinkElement !== null)
		{
			privacyPolicyLinkElement.focus();
		}
		this.checkIfBothTnCAndPrivacyPolicyAgreed();
	}

	checkIfBothTnCAndPrivacyPolicyAgreed()
	{
		if(this.termsAndConditions && this.privacyPolicy)
		{
			this.termsAndPolicyConditionAgreed.emit(true);
		}
		else
		{
			this.termsAndPolicyConditionAgreed.emit(false);
		}
	}

	checkIfTermsAgreed(event : boolean)
	{
		this.termsChecked = event;

		this.service.state.termsModal.buttons[0].disabled = !(this.termsChecked && !this.termsAndConditions);
	}
	checkIfPrivacyAgreed(event: boolean)
	{
		this.privacyChecked = event;
		this.service.state.policyModal.buttons[0].disabled = !(this.privacyChecked && !this.privacyPolicy);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public handleCheckboxClick(event: any): void
	{
		this.openModal(event.target.name);
		event.preventDefault();
	}

	public openModal(id: string): void
	{
		if (id === 'terms')
		{
			this.state.termsModal.hidden = false;
		}
		else
		{
			this.state.policyModal.hidden = false;
		}
		this.service.updateState(this.state);
	}

	public closeModal(): void
	{
		this.state.policyModal.hidden = true;
		this.state.termsModal.hidden = true;
		this.privacyChecked = this.privacyPolicy;
		this.termsChecked = this.termsAndConditions;
		this.checkIfTermsAgreed(this.termsChecked);
		this.checkIfPrivacyAgreed(this.privacyChecked);
	}
}
